module.exports = new __parcel__URL__("soleil.ecdb683b.svg").toString();